import React, { useCallback, useEffect, useState, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BookOpen, Heart } from 'lucide-react';
interface Notification {
  id: number;
  name: string;
  location: string;
  action: string;
  timeAgo: string;
}
const names = ['María', 'Juan', 'Ana', 'Carlos', 'Sofía', 'Luis', 'Elena', 'Pablo', 'Pedro', 'Rosa', 'Miguel', 'Carmen'];
const locations = ['México', 'Colombia', 'España', 'Argentina', 'Chile', 'USA', 'Perú', 'Texas', 'California', 'New York', 'Florida', 'New Jersey', 'Illinois', 'Arizona'];
const actions = ['activó su Plan B', 'descargó la guía', 'eligió su país destino', 'comenzó su auditoría'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function LiveActivityPopup() {
  const [notification, setNotification] = useState<Notification | null>(null);
  useEffect(() => {
    const showNotif = () => {
      setNotification({
        id: Date.now(),
        name: getRandomItem(names),
        location: getRandomItem(locations),
        action: getRandomItem(actions),
        timeAgo: 'hace un momento'
      });
      setTimeout(() => setNotification(null), 4000);
    };
    const interval = setInterval(showNotif, 12000);
    setTimeout(showNotif, 3000); // First one
    return () => clearInterval(interval);
  }, []);
  return <div className="fixed bottom-4 left-4 z-40 max-w-[280px]" data-id="element-214">
      <AnimatePresence data-id="element-215">
        {notification && <motion.div initial={{
        opacity: 0,
        y: 20,
        x: -20
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0
      }} exit={{
        opacity: 0,
        y: 20
      }} className="bg-[var(--bg-card)] rounded-lg p-3 shadow-lg flex items-center gap-3 border border-[var(--border-subtle)]" data-id="element-216">
            <div className="w-8 h-8 rounded-full bg-[var(--accent-soft)] flex items-center justify-center flex-shrink-0 text-[var(--accent)]" data-id="element-217">
              <Heart className="w-4 h-4 fill-current" data-id="element-218" />
            </div>
            <div data-id="element-219">
              <p className="text-xs text-[var(--text-heading)]" data-id="element-220">
                <span className="font-bold" data-id="element-221">{notification.name}</span> de{' '}
                {notification.location}
              </p>
              <p className="text-[10px] text-[var(--text-muted)]" data-id="element-222">
                {notification.action} • {notification.timeAgo}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}